module.exports = __webpack_public_path__ + "img/rechnung-data.3d0d2ab6.svg";